export const RedesActionTypes = {
  API_RESPONSE_SUCCESS: '@@redes/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@redes/API_RESPONSE_ERROR',

  GET_RED: '@@redes/GET_RED',
  LIST_REDES: '@@redes/LIST_REDES',
  ADD_RED: '@@redes/ADD_RED',
  UPDATE_RED: '@@redes/UPDATE_RED',
  DELETE_RED: '@@redes/DELETE_RED',

  RESET: '@@redes/RESET'
}
